import { render, staticRenderFns } from "./SimpleTextarea.vue?vue&type=template&id=199da0e4&"
import script from "./SimpleTextarea.vue?vue&type=script&lang=js&"
export * from "./SimpleTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports